import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleDoubleRight } from '@fortawesome/pro-solid-svg-icons/faAngleDoubleRight';
import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useIntl } from 'react-intl';

import { Breadcrumbs } from 'ui-components/components/breadcrumbs';
import { Text } from 'ui-components/components/text';

import { findPageLabelFromLocation } from '../../nav-items';

import style from './style.module.less';

const InsightsBreadcrumbs = () => {
  const { pathname } = useLocation();
  const intl = useIntl();
  const pieces = pathname.substring(1).split('/');
  const crumbs = pieces.map((location) => {
    const pageLabel = findPageLabelFromLocation(location);
    if (!pageLabel) {
      return null;
    }
    if (pageLabel?.link) {
      return (
        <Link key={location} color='inherit' to={pageLabel.link}>
          {intl.formatMessage(pageLabel.message)}
        </Link>
      );
    }
    return <Text key={location} value={pageLabel} />;
  });

  return (
    <div className={style.breadcrumbs}>
      <Breadcrumbs separator={<FontAwesomeIcon className={style.separator} icon={faAngleDoubleRight} />}>{crumbs}</Breadcrumbs>
    </div>
  );
};

export default InsightsBreadcrumbs;
